import { useEffect, useState } from 'react'
import styles from './RecipientList.module.scss'
import { RestS } from '../../../../rest/rest-service'

export const RecipientList = () => {
  const [recipientList, setRecipientList] = useState([]);

  useEffect(() => {
    RestS.getLendingRecipientList()
      .then((res: any) => {
        if (res?.list) {
          setRecipientList(res.list);
        } else {
          setRecipientList([]);
        }
      })
      .catch(err => {
        console.log(`Error in getting recipient list: ${err}`);
        setRecipientList([]);
      });
  }, []);

  // Sample Data
  // const recipientList = [
  //   {
  //     email: 'asd@gmail.com',
  //     name: 'Ads'
  //   }, {
  //     email: 'asd@gmail.com',
  //     name: 'Ads'
  //   }, {
  //     email: 'asd@gmail.com',
  //     name: 'Ads'
  //   }, {
  //     email: 'asd@gmail.com',
  //     name: 'Ads'
  //   }, {
  //     email: 'asd@gmail.com',
  //     name: 'Ads'
  //   }, {
  //     email: 'asd@gmail.com',
  //     name: 'Ads'
  //   }
  // ]
  return (
    <>
      <div className={styles.sectionRootContainer}>
        <div className={styles.sectionWrapper}>
          <div className={styles.sectionContainer}>
            <div className={styles.sectionHeadingContainer}>
              <div className={styles.sectionHeading}>
                Verify Recipients
              </div>
            </div>
            <div className={styles.subHeading}>
              <p>Your report will only be sent to the below recipients.</p>
              <p>To modify this list, contact Merito.</p>
            </div>
            <div>
              {
                recipientList?.map(recipient => <div className={styles.list}>{recipient.email}</div>)
              }
            </div>
          </div>
        </div>
      </div>
    </>
  )
}